// extracted by mini-css-extract-plugin
export default {"cell":"FormTable_cell__NYHw4","cellCenter":"FormTable_cellCenter__mE9F-","root":"FormTable_root__88z8Z","inputError":"FormTable_inputError__-9Tuh"};